import { axiosInstance } from './axiosInstance';



export const getUserDataByID = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/user/by-id/${id}`);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const userListByDB = async (db) => {
    try {
        const response = await axiosInstance.get(`/api/v1/adminpanel/user/list/${db}`);
        return response;
    } catch (error) {
        return error;
    }
};

export const editUser = async (formData, id) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/user/edit/${id}`, formData);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const registration = async (formData) => {
    try {
        formData = {
            ...formData,
            subscriptiontype: "",
            userCreateBy: "AdminPanel",
            roles: ["Customs"]
        }
        const response = await axiosInstance.post('/api/v1/adminpanel/user/registration', formData);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const updateUserData = async (data) => {
    try {

        const response = await axiosInstance.post(`/api/v1/adminpanel/user/update-data/${data._id}`, data);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};
export const setEmailNotificationData = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/v1/adminpanel/user/update-data-cid/${data.cID}`, { "sendEmailNotification": data.sendEmailNotification });
        return response;
    } catch (error) {
        throw error.response || error;
    }
};